// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as ReactAccordion from "@radix-ui/react-accordion";

var Raw = {};

function Radix_Accordion$Root$SingleType(props) {
  return JsxRuntime.jsx(ReactAccordion.Root, {
              type: "single",
              asChild: props.asChild,
              className: props.className,
              children: props.children,
              defaultValue: props.defaultValue,
              value: props.value,
              onValueChange: props.onValueChange,
              collapsible: props.collapsible,
              disabled: props.disabled,
              dir: props.dir,
              orientation: props.orientation
            });
}

var SingleType = {
  Raw: Raw,
  make: Radix_Accordion$Root$SingleType
};

var Raw$1 = {};

function Radix_Accordion$Root$MultipleType(props) {
  return JsxRuntime.jsx(ReactAccordion.Root, {
              type: "multiple",
              asChild: props.asChild,
              className: props.className,
              children: props.children,
              defaultValue: props.defaultValue,
              value: props.value,
              onValueChange: props.onValueChange,
              disabled: props.disabled,
              dir: props.dir,
              orientation: props.orientation
            });
}

var MultipleType = {
  Raw: Raw$1,
  make: Radix_Accordion$Root$MultipleType
};

var Root = {
  SingleType: SingleType,
  MultipleType: MultipleType
};

var Item = {};

var Header = {};

var Trigger = {};

var Content = {};

export {
  Root ,
  Item ,
  Header ,
  Trigger ,
  Content ,
}
/* react/jsx-runtime Not a pure module */
